import React from "react";
import {observer} from "mobx-react";
import {
    IFlightSearchControllerViewModel
} from "../../../services/flight-search/flight-search-controller/flight-search-controller-view-model.interface";
import {SearchMaskPsoMarketUserOptionsInlineComponent} from "./search-mask-pso-market-user-options-inline.component";
import {SearchMaskPsoMarketUserOptionsPopperComponent} from "./search-mask-pso-market-user-options-popper.component";

interface SearchMaskPsoMarketUserOptionsComponentProps {
    mode: "inline" | "popper";
    flightSearchController: IFlightSearchControllerViewModel;
}
export const SearchMaskPsoMarketUserOptionsComponent: React.FC<SearchMaskPsoMarketUserOptionsComponentProps> = observer((props) => {

    const searchController = props.flightSearchController;
    const psoMarket = searchController.psoMarket;

    if(!psoMarket?.allowNewBookings) {
        return null;
    }

    if(props.mode === "inline") {
        return (
            <SearchMaskPsoMarketUserOptionsInlineComponent psoMarket={psoMarket}
                                                           flightSearchController={searchController}/>
        )
    } else {
        return (
            <SearchMaskPsoMarketUserOptionsPopperComponent psoMarket={psoMarket}
                                                           flightSearchController={searchController}/>
        )
    }
})